import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '@components/Icon';
import SEO from '@components/seo/SEO';
import { BackTop, Card, Divider, Col, Row, Drawer } from 'antd';

// 创建图标封装组件，与LandingPage中相同
const SafeIcon = ({ icon: IconName, useFa = true, ...props }) => {
  if (typeof IconName === 'string' && Icon[IconName]) {
    const IconComponent = Icon[IconName];
    return <IconComponent useFa={useFa} {...props} />;
  }
  
  if (typeof IconName === 'function' || typeof IconName === 'object') {
    return <IconName useFa={useFa} {...props} />;
  }
  
  return null;
};

const About = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // 其他工具数据
  const toolsList = [
    {
      title: "PdfZap",
      description: "免费的PDF批量压缩工具",
      icon: "Zap",
      iconColor: "text-purple-500",
      url: "https://pdfzap.toolooz.com",
      color: "bg-purple-50 dark:bg-purple-900/20"
    },
    {
      title: "LIVP转换器",
      description: "在线批量转换LIVP文件，支持转换为JPG、提取HEIC和MOV格式",
      icon: "Image",
      iconColor: "text-pink-500",
      url: "https://livp.toolooz.com",
      color: "bg-pink-50 dark:bg-pink-900/20"
    },
    {
      title: "TwitDloader",
      description: "输入推文URL，一键下载高清推特视频，支持多种分辨率",
      icon: "FileText",
      iconColor: "text-green-500",
      url: "https://twitdloader.toolooz.com",
      color: "bg-green-50 dark:bg-green-900/20"
    },
    {
      title: "RevizePic",
      description: "专业的在线图像画质增强工具，支持超分辨率增强、智能降噪、色彩优化等",
      icon: "ImagePlus",
      iconColor: "text-pink-500",
      url: "https://revizepic.toolooz.com",
      color: "bg-pink-50 dark:bg-pink-900/20"
    },
    {
      title: "纸由我",
      description: "自定义打印纸生成器，设计横线纸、方格纸、点阵纸、音乐纸等",
      icon: "FileText",
      iconColor: "text-purple-500",
      url: "https://paperme.toolooz.com",
      color: "bg-purple-50 dark:bg-purple-900/20"
    },
    {
      title: "视频转换宝",
      description: "免费的视频转GIF动图、实况照片(LIVP)工具",
      icon: "Video",
      iconColor: "text-blue-500",
      url: "https://livecapture.toolooz.com",
      color: "bg-blue-50 dark:bg-blue-900/20"
    },
    {
      title: "SlimPic瘦图",
      description: "免费的将图片批量压缩和转换为AVIF、JPEG、JXL、PNG、WebP等格式",
      icon: "Minimize2",
      iconColor: "text-pink-500",
      useFa: true,
      url: "https://slimpic.toolooz.com",
      color: "bg-pink-50 dark:bg-pink-900/20"
    },
    {
      title: "图裁刀",
      description: "专业的在线图片裁剪工具，支持多个社交媒体平台预设尺寸",
      icon: "Scissors",
      iconColor: "text-purple-500",
      url: "https://snaptrim.toolooz.com",
      color: "bg-purple-50 dark:bg-purple-900/20"
    },
    {
      title: "图拼宝",
      description: "免费、简单易用的在线图片拼接工具，提供多种网格和拼贴布局模板",
      icon: "Grid",
      iconColor: "text-purple-500",
      useFa: true,
      url: "https://picweave.toolooz.com",
      color: "bg-purple-50 dark:bg-purple-900/20"
    },
    {
      title: "抠小宝",
      description: "基于AI技术的免费智能抠图工具，支持批量处理图片、一键换底色和背景",
      icon: "Image",
      iconColor: "text-pink-500",
      url: "https://kouxiaobao.toolooz.com",
      color: "bg-pink-50 dark:bg-pink-900/20"
    },
    {
      title: "图尺匠",
      description: "免费的在线图片尺寸调整工具，直接在浏览器中完成所有操作",
      icon: "Maximize",
      iconColor: "text-blue-500",
      url: "https://picsizer.toolooz.com",
      color: "bg-blue-50 dark:bg-blue-900/20"
    },
    {
      title: "图切宝",
      description: "帮助您轻松分割长图，完美适配多种社交媒体的发布需求",
      icon: "Scissors",
      iconColor: "text-amber-500",
      url: "https://snapcute.toolooz.com",
      color: "bg-amber-50 dark:bg-amber-900/20"
    },
    {
      title: "手抠宝",
      description: "简单易用的轻量级手动抠图工具，轻松实现图片背景透明化",
      icon: "Scissors",
      iconColor: "text-green-500",
      url: "https://handtrim.toolooz.com",
      color: "bg-green-50 dark:bg-green-900/20"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-purple-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      <SEO 
        title="关于我们 - 图美啦开发团队 | 在线图片美化工具"
        description="了解图美啦背后的开发团队和故事。我们致力于创建简单、高效、免费的在线图片美化工具，帮助用户轻松制作专业级图片。"
        keywords="图美啦,图片美化团队,独立开发者,在线工具开发,免费图片工具,图片编辑器开发"
        canonicalUrl="https://snapbeautify.toolooz.com/about"
      />
      {/* 导航栏 */}
      <header className="bg-white dark:bg-gray-900 shadow-sm">
        <div className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <Link to="/" className="flex items-center text-2xl font-bold text-purple-600 dark:text-purple-400">
                <img src="/favicon.svg" alt="图美啦" width="32" height="32" className="mr-2" />
                图美啦
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="Home" size={16} className="mr-1" />
                首页
              </Link>
              <Link to="/quick-start" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="BookOpen" size={16} className="mr-1" />
                快速上手
              </Link>
              <Link to="/about" className="font-medium text-purple-600 dark:text-purple-400 flex items-center">
                <SafeIcon icon="User" size={16} className="mr-1" />
                关于我们
              </Link>
            </nav>
            <div className="flex md:hidden">
              <button 
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                onClick={() => setMobileMenuOpen(true)}
              >
                <SafeIcon icon="Menu" size={24} />
              </button>
            </div>
          </div>
        </div>
        
        {/* 移动设备导航菜单 */}
        <Drawer
          title="导航菜单"
          placement="right"
          onClose={() => setMobileMenuOpen(false)}
          open={mobileMenuOpen}
          width={250}
        >
          <div className="flex flex-col space-y-4">
            <Link 
              to="/" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="Home" size={16} className="mr-1" />
              首页
            </Link>
            <Link 
              to="/quick-start" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="BookOpen" size={16} className="mr-1" />
              快速上手
            </Link>
            <Link 
              to="/about" 
              className="font-medium text-purple-600 dark:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="User" size={16} className="mr-1" />
              关于我们
            </Link>
            <Link 
              to="/features" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="Star" size={16} className="mr-1" />
              功能介绍
            </Link>
            <Link 
              to="/faq" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="HelpCircle" size={16} className="mr-1" />
              常见问题
            </Link>
            <div className="border-t border-gray-200 dark:border-gray-700 my-2 pt-2">
              <Link 
                to="/privacy" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="Shield" size={16} className="mr-1" />
                隐私政策
              </Link>
              <Link 
                to="/terms" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="FileText" size={16} className="mr-1" />
                使用条款
              </Link>
              <Link 
                to="/copyright" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="Award" size={16} className="mr-1" />
                版权声明
              </Link>
            </div>
          </div>
        </Drawer>
      </header>

      {/* 主要内容区域 */}
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden mb-8">
            <div className="p-8">
              <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6 flex items-center">
                <SafeIcon icon="User" className="mr-3 text-purple-600 dark:text-purple-400" size={28} useFa={true} />
                关于我们
              </h1>

              <div className="prose dark:prose-invert max-w-none">
                <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                  <SafeIcon icon="BookOpen" className="mr-2 text-purple-500 dark:text-purple-400" size={20} useFa={true} />
                  开发者故事
                </h2>
                
                <div className="bg-purple-50 dark:bg-purple-900/10 p-6 rounded-lg border-l-4 border-purple-500 mb-6">
                  <p className="text-gray-700 dark:text-gray-300 italic">
                    "每次看到那些平淡无奇的截图，我总会想，如果能给它们添上一点色彩、一点设计感，那该有多好。"
                  </p>
                </div>
                
                <p className="text-gray-600 dark:text-gray-300">
                  我平时喜欢鼓捣点小东西，解决生活和工作里的小麻烦。
                </p>
                
                <p className="text-gray-600 dark:text-gray-300 mt-4">
                  我一直觉得，图片这东西要是能稍微美化一下，效果会好很多。比如我经常要写点笔记，或者搞个产品截图发出去，可每次一看那些干巴巴的截图——背景单调、边角生硬，总觉得差点意思。心想，要是能给它加点色彩、弄个边框啥的，看着不就舒服多了？
                </p>
                
                <p className="text-gray-600 dark:text-gray-300 mt-4">
                  于是我开始找工具，想把截图搞得好看点。市面上美化图片的软件不少，可用下来总觉得差点火候。有些在线工具倒是方便，可界面乱糟糟的，选项多得让人晕，点来点去也不知道咋弄好看。还有些免费版功能少得可怜，想加个像样的边框还得掏钱开会员，要么弄完图上还多个水印。
                </p>
                
                <p className="text-gray-600 dark:text-gray-300 mt-4">
                  我就纳闷："难道就没个简单点的办法吗？就想随便打开个网页，把截图美化一下，不用装软件、不用花钱、不用费脑子，咋就这么难呢？"
                </p>
                
                <p className="text-gray-600 dark:text-gray-300 mt-4">
                  那天晚上，我一边刷手机一边琢磨，越想越觉得市场缺个这样的东西——一个在线的、简单好用的图片美化工具，专为像我这样的人设计，不需要多复杂的功能，就够日常用。于是，"图美啦"的想法就冒出来了。
                </p>
                
                <p className="text-gray-600 dark:text-gray-300 mt-4">
                  "图美啦"做好后，我拿那张软件截图试了试。传上去后，先加了个渐变背景，再调了个圆角阴影，看着就高级了不少。然后用箭头标了个重点，加了几个字说明，挑了个亮眼的颜色。觉得颜色有点平淡，又点了复古滤镜，效果一下就出来了。弄完保存了个PNG，干干净净没水印，发到群里，朋友都说："这截图咋弄得这么漂亮？"
                </p>
                
                <p className="text-gray-600 dark:text-gray-300 mt-4">
                  我挺满意，心想这工具还真挺符合我当初的想法：
                </p>
                
                <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-1 mt-2">
                  <li>无需安装，打开网页就能使用</li>
                  <li>操作简单直观，即使是非技术用户也能快速上手</li>
                  <li>提供丰富的美化选项，但不会让用户感到复杂</li>
                  <li>完全免费，没有复杂的付费墙或广告干扰</li>
                  <li>保护用户隐私，处理过程全部在本地完成</li>
                </ul>
                
                <p className="text-gray-600 dark:text-gray-300 mt-4">
                  花了十来分钟，截图从平平无奇变得有模有样，自己动手的感觉还挺带劲。希望能帮助更多像我一样需要美化图片的人。
                </p>
                
                <p className="text-gray-600 dark:text-gray-300 mt-4">
                  作为独立开发者，我相信好的工具不必复杂，但一定要解决实际问题。图美啦只是我开发的众多实用工具中的一个，我希望它能为您的工作和生活带来一点便利和美好。
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
            <div className="p-8">
              <h2 className="text-2xl font-semibold mb-6 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Grid" className="mr-2 text-purple-500 dark:text-purple-400" size={24} useFa={true} />
                我的其他工具
              </h2>

              <p className="text-gray-600 dark:text-gray-300 mb-8">
                除了图美啦外，我还开发了许多其他免费实用的在线工具。每一款工具都专注于解决特定的问题，希望能为您的工作与生活带来便利。
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {toolsList.map((tool, index) => (
                  <a key={index} href={tool.url} target="_blank" rel="noopener noreferrer" className="no-underline">
                    <Card className={`${tool.color} hover:shadow-lg transition-shadow duration-300 h-full border-0`}>
                      <div className="flex flex-col h-full">
                        <div className="flex items-center mb-3">
                          <div className={`w-10 h-10 rounded-full ${tool.iconColor.replace('text', 'bg').replace('500', '100')} dark:bg-opacity-30 flex items-center justify-center mr-3`}>
                            <SafeIcon icon={tool.icon} className={tool.iconColor} size={20} useFa={true} />
                          </div>
                          <h3 className="text-lg font-medium text-gray-800 dark:text-white m-0">{tool.title}</h3>
                        </div>
                        <p className="text-gray-600 dark:text-gray-300 text-sm flex-grow">{tool.description}</p>
                        <div className="mt-4 text-right">
                          <span className="text-purple-500 dark:text-purple-400 text-sm flex items-center justify-end">
                            访问工具
                            <SafeIcon icon="ArrowRight" size={14} className="ml-1" useFa={true} />
                          </span>
                        </div>
                      </div>
                    </Card>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* 页脚区域 */}
      <footer className="bg-gray-800 text-white py-8 mt-12">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <Link to="/" className="flex items-center text-xl font-bold text-white">
                <img src="/favicon.svg" alt="图美啦" width="24" height="24" className="mr-2" />
                图美啦
              </Link>
            </div>
            
            <div className="flex space-x-8">
              <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors text-sm">隐私政策</Link>
              <Link to="/terms" className="text-gray-300 hover:text-white transition-colors text-sm">使用条款</Link>
              <Link to="/copyright" className="text-gray-300 hover:text-white transition-colors text-sm">版权声明</Link>
            </div>
            
            <div className="mt-4 md:mt-0 text-gray-400 text-sm">
              © {new Date().getFullYear()} 图美啦 | SnapBeautify
            </div>
          </div>
        </div>
      </footer>
      
      <BackTop>
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-purple-600 hover:bg-purple-700 text-white shadow-lg">
          <SafeIcon icon="ChevronUp" size={20} useFa={true} />
        </div>
      </BackTop>
    </div>
  );
};

export default About; 